/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 10 2023
 **/
import styled from "@emotion/styled";

import { Column, Row } from "@/frameworks/designStuff/components";

export const HeaderIconList = styled(Row.div)`
	gap: 3px;
`;

export const Header = styled(Row)`
	width: 100%;
	padding: 16px 12px 0px 24px;
`;

export const Wrapper = styled(Column.div)`
	height: 100%;
	max-width: 600px;
`;

export const Body = styled(Column.div)`
	width: 100%;
	flex-grow: 1;
	align-items: center;
	justify-content: center;
	padding: 12px 0;
`;

export const InnerBody = styled(Column.div)`
	width: 100%;
	padding: 8px 0;
`;

export const UserList = styled(Column.ul)`
	margin-top: 16px;
	width: 100%;
	overflow: auto;
	max-height: 316px;
	min-height: 316px;
	min-width: 576px;
`;

export const Footer = styled(Row.div)`
	padding: 10px 20px;
	width: 100%;
	flex-shrink: 0;
	border-top: 1px solid ${({ theme }) => theme.colors.neutral_50_20};
`;

export const CheckIconWrap = styled.span`
	display: inline-flex;
	justify-content: center;
	align-items: center;

	width: 32px;
	height: 32px;
	border-radius: 32px;
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
`;

export const InnerContent = styled(Row)`
	width: 100%;
	padding: 8px 20px 0 20px;
`;

export const LI = styled.li`
	width: 100%;
	padding: 0 8px 0 20px;
`;
